// /**
//  * Partner - Add User
//  */

// React
import React, {useEffect, useState} from 'react';

// Components
import ListUser from './list-users';

// Helper
import {removeEmptyValueObject, UserRoles} from '../../utils/helpers';

// Type
import {PayloadUpdate} from './interfaces';
import {User} from '../users/interfaces';

type Props = {
  usersList: User[];
  partnerId: number;
  handleClose: () => void;
  usersBeAdminPartnerDispatch: (payload: any) => void;
  updatePartnerDispatch: (payload: PayloadUpdate) => void;
};

export default function Add(props: Props) {
  const [filtersValues, setFiltersValues] = useState({} as any);

  useEffect(() => {
    getUsersBeAdminPartner();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const getUsersBeAdminPartner = () => {
    props.usersBeAdminPartnerDispatch({
      ...removeEmptyValueObject(filtersValues),
      'partnersId.specified': false,
    });
  };

  return (
    <>
      <ListUser
        partnerId={props.partnerId}
        data={props.usersList}
        hasSelectUser
        updatePartnerDispatch={props.updatePartnerDispatch}
        handleClose={props.handleClose}
      />
    </>
  );
}
